module.exports = __webpack_public_path__ + "media/payment_options/diners-9f2e5d56.png";